import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
// import ActivePageProvider from './context/ActivePageProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    {/* <ActivePageProvider> */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
    {/* </ActivePageProvider> */}
  </React.StrictMode>
)
